import { useMemo } from "react";

export const MetaTags = ({ metatags }) => {
  const list = useMemo(() => {
    if (!metatags) return [];

    return Object.entries(metatags).filter(
      (item) => item[0] !== "_uid" && item[0] !== "plugin"
    );
  }, [metatags]);

  return (
    <>
      {list.map((item) => {
        if (!item[1]) {
          return null;
        }
        if (item[0] === "title") {
          return <title>{item[1]}</title>;
        }
        return <meta name={item[0].replaceAll("_", ":")} content={item[1]} />;
      })}
    </>
  );
};
